module.exports = __webpack_public_path__ + "static/media/icon_02.9e218fd4.svg";